export { VideoGalleryRenderer } from './VideoGalleryRenderer'
